import { color, fontSize } from '../../theme/tokens';

/**
 * The provenance footer (spec 006 T111, FR-A06).
 *
 * ## ⚠ EXACTLY TWO source names: `Nexus` and `Run Rate`
 *
 * Never `BigQuery` — everything reaches BigQuery, so naming the warehouse separates nothing and
 * is a line a reader stops reading. Never a table name either: a reader has never heard of
 * `ch_run_rate`.
 *
 * The same two names the rest of the product already uses
 * (`components/Breakdown/provenance.ts`), so one figure does not acquire a different lineage
 * depending on which surface it appears on.
 */

export type ProvenanceSource = 'Nexus' | 'Run Rate';

export interface TurnFooterProps {
  sources: readonly ProvenanceSource[];
  /** ⚠ Exactly one clock, named. An answer carrying both labels is a defect. */
  clock: string | null;
  /** ⚠ Prints even when the two agree; absent means no twin, not "they matched". */
  reconciliation: string | null;
}

export function TurnFooter({ sources, clock, reconciliation }: TurnFooterProps) {
  if (!clock && sources.length === 0) return null;

  return (
    <div style={{ marginTop: 8, fontSize: fontSize.caption, color: color.inkMuted }}>
      {clock ? <div>{clock}</div> : null}

      {/*
        ⚠ A LINE, never a column and never a row. A table with a live column beside a snapshot
        column is one grid describing no moment in time — keep the comparison out of the grid.
      */}
      {reconciliation ? <div>{reconciliation}</div> : null}

      {sources.length > 0 ? (
        <div style={{ color: color.inkHint }}>Source: {sources.join(' and ')}</div>
      ) : null}
    </div>
  );
}
